import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction'
import { useEffect, useState } from 'react';
import { text } from 'stream/consumers';
import { v4 as uuidv4 } from 'uuid'
import {Modal,ModalHeader,ModalBody,ModalFooter,Input,Button } from "reactstrap";
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import CancelIcon from '../svg/Cancel';


type calendarProps ={
    ChakId:string,
    
}

const Calendar = ({ChakId}:calendarProps)=>{
      
 
      const[events,setEvents] = useState<any>([])
      const[isModalOpen,setIsModalOpen] = useState(false);
      const[inputValue,setInputValue] = useState('');
      const[selectedDate,setSelectedDate] = useState(null);
      const[id,setId] = useState('');


       const handleDateClick =(info:any) =>{
        setIsModalOpen(true)
       setSelectedDate(info.dateStr)    
        }

        const handleEventClick =(clickInfo:any) =>{
             setId(clickInfo.event.id)
             setInputValue(clickInfo.event.title)
             setIsModalOpen(true)
        }
             useEffect(()=>{
                   const getSchedule = async()=>{
                     try{
                        const response = await ApiService.axiosApi(`/scheduelq/schedule:${ChakId}`,{
                           method:'GET'
                        })
                        
                        if(response.success){
                                                                   
                          const apiEvents =response.data.map((event:any)=>(
                            {
                              id:event.id,
                              title:'schedule',
                              start:new Date(event.startDate).toISOString(),
                              backgroundColor: '#c2f6ee',
                                   
                              classNames: ['custom-event']
                               
                            } 
                          ))
                          
                          setEvents(apiEvents)
                        }else{
                            toast.error(response.message || 'unab le to get events')
                        } 
                     } catch(error){
                        toast.error('unavle to get events')
                     }
                   }
                 if(ChakId){getSchedule();}

             },[ChakId])
             
           /* const action = prompt(
                `Edit title or type "delete" to remove event "${clickInfo.event.title}":`,
                clickInfo.event.title
            )

            if (action === 'delete') {
               
              } else if (action && action !== clickInfo.event.title) {
                setEvents(
                  events.map((event:any) =>
                    event.id .toString() === clickInfo.event.id.toString() ? { ...event, title: action } : event
                  )
                );
              }*/
        
    return(
         <>
        
         
            
          
        <div className='mt-3 calendar-custom'
        > 
              <FullCalendar
               key={events.length}
          plugins={[dayGridPlugin,timeGridPlugin,interactionPlugin]}
          initialView={"dayGridMonth"}
          headerToolbar={{
              start: "today,prev,next",
              center:"title",
              end:"dayGridMonth,timeGridWeek,timeGridDay"
          }}
          events={events}
          selectable={true}
          dateClick={handleDateClick}
          eventClick={handleEventClick}
          height={400}
         />
        </div>
        
     

        <Modal isOpen={isModalOpen}
             toggle={() => setIsModalOpen(!isModalOpen)}>
          <ModalHeader>
                Enter The Event You Want To Add
          </ModalHeader>
          <ModalBody>
              
              <Input
                 name="text"
                 type="textarea"
                 value={inputValue}
                 onChange={(e) => setInputValue(e.target.value)}
              />
             
          </ModalBody>
             
          <ModalFooter>
              <Button
              className='me-1'
              color='primary'
              size='sm'
                onClick={() =>{
                     if(inputValue&&selectedDate){
                        setEvents([
                            ...events,
                           {
                             id:uuidv4(),
                             title:inputValue,
                             start: selectedDate
                           }
                        ]);
                     }

                     setSelectedDate(null);
                     setInputValue('')
                     setIsModalOpen(false)

                }}
              >
                  Confirm
              </Button>

              <Button
              color='danger'
              size='sm'
               onClick={()=>{
                   if(id && inputValue){
                    
                    setEvents(events.filter((event:any) => event.id.toString() !== id.toString())); 
                    setIsModalOpen(false)
                    setInputValue('')
                   }
               }}>
                  Delete
              </Button>
          </ModalFooter>
      </Modal>
        </>

    )
}

export default Calendar;